module.exports = __webpack_public_path__ + "static/media/ZhiBo4.528aefbc.png";